export const toPixel = (value: number): string => `${value}px`
